import { makeStyles } from '@mui/styles';
import { ITheme } from '../../../../theme/types';

const useStyles = makeStyles((theme: ITheme) => ({
  marginTop: {
    marginTop: theme.spacing(3),
  },
}));

export default useStyles;